import { createSlice } from '@reduxjs/toolkit';
import { userLoginAction, userProfileAction, refreshTokenAction } from 'redux/actions/auth';
import Gleap from 'gleap';
import { env } from '../../env'
import * as Sentry from "@sentry/react";

const initialState = {
  user: {},
  loading: false,
  error: '',
};

// First import your thunk then add thunk lifecycle handlers
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logoutUser: () => {
      localStorage?.removeItem('token');
      localStorage?.removeItem('user');
      localStorage.removeItem('expires');
    },
  },
  extraReducers: {
    [userLoginAction.pending]: (state) => {
      state.loading = true;
    },
    [userLoginAction.fulfilled]: (state, action) => {
      state.user = action.payload.user;
      state.loading = false;
      localStorage.setItem('token', action.payload.access_token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('expires', new Date(new Date().getTime() + action.payload.expires_in * 1000));
      localStorage.setItem('auth', 'refresh');

      Gleap.identify(`${action.payload.user.email}@${env.REACT_APP_API_URL}`, {
        name: action.payload.user.name,
        email: action.payload.user.email,
        customData: {
          clientAccount: env.REACT_APP_API_URL,
        },
      });
    },
    [refreshTokenAction.pending]: (state) => {
      state.loading = true;
    },

    [refreshTokenAction.fulfilled]: (state, action) => {
      state.user = action.payload.user;
      state.loading = true;
      localStorage.setItem('token', action.payload.access_token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('expires', new Date(new Date().getTime() + action.payload.expires_in * 1000));
      localStorage.removeItem('auth');
    },
    [refreshTokenAction.rejected]: (state) => {
      state.loading = false;
    },
    [userProfileAction.pending]: (state) => {
      state.loading = true;
    },
    [userProfileAction.fulfilled]: (state, action) => {
      state.user = action.payload;
      state.loading = false;
      Sentry.setUser({ email: action.payload.email });
    },
    [userProfileAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const { logoutUser } = authSlice.actions;
// export the reducer to be passed to configureStore
export default authSlice.reducer;
